import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MasterData } from 'app/models/admin/master-data.model';
import { environment } from 'environments/environment';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class MasterDataService {
    private activeTrackingContactSubject = new BehaviorSubject<{ email?: string; phone?: string } | null>(null);
    public activeTrackingContact$ = this.activeTrackingContactSubject.asObservable();
    private masterDataCache: any = null;

    constructor(
        private _httpClient: HttpClient,
    ) { }

    setActiveTrackingContact(contact: { email?: string; phone?: string } | null): void {
        this.activeTrackingContactSubject.next(contact);
    }

    getMasterData(): Observable<any> {
        if (this.masterDataCache) {
            return of({ status: 200, message: 'OK.', data: this.masterDataCache });
        }
        return this._httpClient.get(environment.apiBaseUrl + '/master-data/').pipe(
            tap((res: any) => {
                if (res && res.data) {
                    this.masterDataCache = res.data;
                }
            })
        );
    }

    addMasterData(data: MasterData): Observable<any> {
        this.masterDataCache = null;
        return this._httpClient.post(environment.apiBaseUrl + '/master-data/', data);
    }

    updateMasterDataById(id: string, data: MasterData): Observable<any> {
        this.masterDataCache = null;
        return this._httpClient.put(environment.apiBaseUrl + '/master-data/' + id, data);
    }

    scrapeProduct(): Observable<any> {
        return this._httpClient.get(environment.apiBaseUrl + '/master-data/scrape-product');
    }

    getNjourImageUrl(): Observable<any> {
        return this._httpClient.get(environment.apiBaseUrl + '/master-data/njour-image');
    }
}
